var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import "./Logo.scss";
export var Logo = function (_a) {
    var src = _a.src, alt = _a.alt, _b = _a.size, size = _b === void 0 ? "small" : _b, _c = _a.align, align = _c === void 0 ? "center" : _c;
    var width = size === "small" ? 60 : 200;
    return (_jsx("div", __assign({ className: "general-logo general-logo--".concat(align) }, { children: _jsx("img", { src: src, alt: alt || "logo", width: width }) })));
};
